import { ChangeType } from 'types';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import { EditGatewayFormData } from 'containers/jobsiteConfiguration/types';
import { EditableGateway } from './types';

export const getFormInputs = ({
  gateway,
  gateways,
}: {
  gateway?: EditableGateway;
  gateways: EditableGateway[];
}): TypedFormInputs<EditGatewayFormData> => ({
  name: {
    element: FormInputTypes.Field,
    label: 'Name',
    elementProps: {
      placeholder: 'e.g. North Gate, South Entry, Loading Dock',
    },
    layout: [GridColSpan.SpanFull],
    validation: {
      required: true,
      validate: (value: string): string | true => {
        const isDuplicate = gateways
          ?.filter(
            (g) =>
              g.id !== gateway?.id && // Exclude current gateway when editing
              g.changeType !== ChangeType.Removed, // Exclude gateways marked for deletion
          )
          .some((g) => g.name === value);
        return isDuplicate ? 'Gateway name already exists' : true;
      },
    },
  },
});

export const getDefaultValues = (
  gateway?: EditGatewayFormData,
): EditGatewayFormData => {
  const { name } = gateway ?? {};
  return {
    name: name ?? '',
  };
};
